import React, { useEffect, useState } from 'react'
import * as Styled from './TiktokPosts.styled'
import { Row, Column } from '@zera-admin/page'

import Analysis from '../../components/analysis'
import TiktokCard from '../../components/tiktok-card'

import { TiktokPostsProps } from './types'

import UpdateButton from '../../components/update-button/UpdateButton'
import { Post } from '../../widgets/types'
import WidgetLayout from '../../widgets/widget-layout'
import { AnalysisData } from '../../components/analysis/types'

import { useFlagcardContext } from 'app/contexts/flagcard'
import { getAgendaReportTiktok } from 'services/http/report/agenda-report-4/endpoint'

const TiktokPosts: React.FC<TiktokPostsProps> = ({
  date,
  isEditValue,
  setIsEditValue,
  pageNumber,
  title,
  data,
  metaData,
}) => {
  const [postData, setPostData] = useState<Post | undefined>(data)
  const [videoId, setVideoId] = useState<string | undefined>('')

  const [pageData, setPageData] = useState<{
    title: string
    pageNumber: number
  }>({ title: title, pageNumber: pageNumber })

  const [editMode, setEditMode] = useState<boolean>(false)

  const [flagCard] = useFlagcardContext()

  useEffect(() => {
    if (isEditValue === pageNumber) {
      setEditMode(true)
    }
  }, [isEditValue, pageNumber])

  useEffect(() => {
    if (isEditValue === -1) {
      setPostData(data)
      setPageData({ title: title, pageNumber: pageNumber })
    }
  }, [isEditValue, data, title, pageNumber])

  const handleDeleteVideo = () => {
    setPostData(undefined)
  }

  const addVideo = () => {
    getAgendaReportTiktok({
      GroupId: metaData?.GroupId,
      VideoId: videoId,
    })
      .then((res) => {
        setPostData(res.data.data)
      })
      .catch((err) => {
        console.log(err)
        flagCard.add({
          appearance: 'error',
          title: 'Bir hata oluştu',
          children:
            'Veritabanında video bulunamadı. Lütfen video ID bilgisini kontrol ediniz.',
        })
      })
  }

  const onChange = (key: string, value: string) => {
    postData && setPostData({ ...postData, [key]: value })
  }

  const onChangePageData = (key: string, value: string) => {
    setPageData({
      ...pageData,
      [key]: value,
    })
  }

  const editProps = {
    isEditValue: isEditValue,
    setIsEditValue: setIsEditValue,
    pageNumber: pageData.pageNumber,
    metaData,
  }

  return (
    <WidgetLayout
      asideDate={date}
      asideTitle={pageData.title}
      pageNumber={pageData.pageNumber}
      onChange={onChangePageData}
      editMode={editMode}
      flagShortCode={metaData?.flagShortCode}
    >
      <Styled.TiktokAnalysisWrapper>
        <UpdateButton
          {...editProps}
          contentData={{
            Post: postData,
          }}
          title={pageData.title}
          editMode={editMode}
          setEditMode={setEditMode}
        />

        <Styled.TiktokAnalysisContainer>
          <Row xs={{ justify: 'center' }}>
            {postData ? (
              <Column
                className="tiktok"
                xs={{ size: postData?.Analysis ? 7 : 8 }}
              >
                <TiktokCard
                  data={postData}
                  editMode={editMode}
                  onChange={onChange}
                />
                {editMode && (
                  <button className="delete-tiktok" onClick={handleDeleteVideo}>
                    X
                  </button>
                )}
              </Column>
            ) : (
              <Column xs={{ size: 8 }}>
                <div className="add-tiktok">
                  <input
                    type="text"
                    placeholder="Enter video id"
                    onChange={(e) => setVideoId(e.target.value)}
                  />
                  <button onClick={addVideo}>Add Video</button>
                </div>
              </Column>
            )}

            {postData?.Analysis && (
              <Column xs={{ size: 5 }}>
                <Analysis
                  editMode={editMode}
                  onChange={onChange}
                  data={postData as AnalysisData}
                />
              </Column>
            )}
          </Row>
        </Styled.TiktokAnalysisContainer>
      </Styled.TiktokAnalysisWrapper>
    </WidgetLayout>
  )
}

export default TiktokPosts
